<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Coleta Voluntária</h5>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col">
        <form v-on:submit.prevent="save">
          <fieldset>
            <legend>Usuário</legend>
            <div class="form-group">
              <label for="cooperado">Usuário (caso não encontre, preencha os campos abaixo)</label>
              <vue-bootstrap-typeahead
                v-model="form.cooperado"
                :data="cooperados"
                :serializer="getNameLogin"
                @hit="hit"
                @input="onInput"
              />
              <small
                class="text-danger"
                v-if="!form.usuario"
              >* Selecione um usuário/unidade previamente cadastrado, caso não esteja listando cadastre usando os campos abaixo.</small>
            </div>

            <div class="form-group" v-if="!form._id">
              <label for="nome">Nome * Obrigatório</label>
              <input
                :disabled="form.cooperadoId"
                required
                v-model="form.nome"
                id="nome"
                type="text"
                class="form-control"
              />
            </div>

            <div class="form-group" v-if="!form._id">
              <label for="login">Login * Obrigatório</label>
              <input
                :disabled="form.cooperadoId"
                required
                v-model="form.login"
                id="login"
                type="text"
                class="form-control"
              />
            </div>

            <div class="row">
              <div class="col">
                <fieldset>Atividades</fieldset>
                <div class="form-group mt-2">
                  <button
                    type="button"
                    @click="addAt"
                    class="btn btn-primary btn-raised btn-block"
                  >Adicionar</button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col" v-for="(item, index) in form.atividades" :key="index">
                <div class="form-group">
                  <label :for="'atividade' + index">Atividade</label>
                  <atividades v-model="form.atividades[index].atividade" :id="'atividade' + index" />
                </div>

                <div class="form-group mt-2">
                  <button
                    type="button"
                    @click="removerAtTec(index)"
                    class="btn btn-danger btn-raised btn-sm btn-block"
                  >Remover</button>
                </div>
              </div>
            </div>
          </fieldset>

          <hr />

          <fieldset>
            <legend>Coleta</legend>

            <div class="form-group">
              <label for="data">Data</label>
              <input v-model="form.data" id="data" type="date" class="form-control" />
            </div>

            <div class="form-group">
              <label for="manutencao" class="col-form-label">Resíduos de manutenção</label>
              <input
                type="text"
                @focus="form.manutencao === 0 ? form.manutencao = '' : null"
                v-model="form.manutencao"
                class="form-control"
                id="manutencao"
              />
            </div>

            <div class="form-group">
              <label for="vet" class="col-form-label">Resíduos veterinários</label>
              <input
                type="text"
                @focus="form.vet === 0 ? form.vet = '' : null"
                v-model="form.vet"
                class="form-control"
                id="vet"
              />
            </div>

            <div class="form-group">
              <label for="pneu" class="col-form-label">Pneus</label>
              <input
                type="text"
                @focus="form.pneu === 0 ? form.pneu = '' : null"
                v-model="form.pneu"
                class="form-control"
                id="pneu"
              />
            </div>

            <div class="form-group">
              <label for="lampada" class="col-form-label">Lâmpadas</label>
              <input
                type="text"
                @focus="form.lampada === 0 ? form.lampada = '' : null"
                v-model="form.lampada"
                class="form-control"
                id="lampada"
              />
            </div>

            <div class="form-group">
              <label for="outros" class="col-form-label">Outros</label>
              <input
                type="text"
                @focus="form.outros === 0 ? form.outros = '' : null"
                v-model="form.outros"
                class="form-control"
                id="outros"
              />
            </div>

            <div class="form-group">
              <button
                @click="save"
                type="button"
                class="btn btn-primary btn-raised btn-block"
              >Salvar</button>
              <router-link
                to="/residuos/coleta"
                class="btn btn-danger btn-raised btn-block"
              >Cancelar</router-link>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ls from "local-storage";
import moment from "moment";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  components: {
    VueBootstrapTypeahead
  },
  data() {
    return {
      form: {
        cooperado: "",
        nome: "",
        login: "",
        atividades: [],
        cooperadoId: false,
        data: moment().format("YYYY-MM-DD"),
        manutencao: 0,
        vet: 0,
        pneu: 0,
        lampada: 0,
        outros: 0
      },
      cooperados: [],
      route: "/residuos/coleta"
    };
  },
  methods: {
    removerAtTec(index) {
      this.form.atividades.splice(index, 1);
    },
    addAt() {
      this.form.atividades.push({
        atividade: "AGRICULTURA",
      });
    },
    save() {
      if (this.form.nome && this.form.login) {
        const method = this.$route.params.id ? this.$http.put : this.$http.post;

        method(this.route, this.form).then(response => {
          if (response.data.success) {
            this.$toasted.show("Cadastrado com sucesso!", this.$custom.success);
            this.$router.push(this.route);
          } else {
            this.$toasted.show(`${response.data.err}`, this.$custom.error);
          }
        });
      } else {
        this.$toasted.show("Preencha nome e login!", this.$custom.error);
      }
    },
    getNameLogin(input) {
      return `${input.login} - ${input.nome}`;
    },
    hit(input) {
      this.form.cooperadoId = input._id;
      this.form.nome = input.nome;
      this.form.login = input.login;
      this.form.atividades = input.atividades;
    },
    onInput() {
      console.log("input");
      const coopTemQueSer = `${this.form.login} - ${this.form.nome}`;
      if (
        !this.form.cooperadoId ||
        this.form.cooperado !== coopTemQueSer ||
        this.form.cooperado === ""
      ) {
        this.form.nome = "";
        this.form.login = "";
        this.form.cooperadoId = "";
      }
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$http
        .get(`${this.route}/${this.$route.params.id}`)
        .then(response => {
          if (response.data) this.form = response.data;
        });
    }

    this.$http.post(`${this.route}/cooperados`).then(response => {
      if (response.data) this.cooperados = response.data;
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/components/app/residuos/coleta/Form.vue